import React, { Suspense } from 'react';
import FullScreenLoader from 'components/Loaders/FullScreenLoader/';

// eslint-disable-next-line react/display-name
const Loadable =
  (Component: React.ComponentType<React.JSX.IntrinsicAttributes>) => (props: React.JSX.IntrinsicAttributes) => (
    <Suspense fallback={<FullScreenLoader />}>
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
